import { History } from 'history';
import { isInternal } from '@/infrastructure/auth';
import { logger } from '@/infrastructure/logger';
import { BUGLY_LOGIN_STORAGE_KEY } from '@/presentation/hooks/user/types';
import { clearAllCookie } from '@raft/utils/src/cookie';

export function logout() {
  localStorage.removeItem(BUGLY_LOGIN_STORAGE_KEY);
  clearAllCookie();
  const currentUrl = encodeURIComponent(location.href);
  // 区分内网和外网跳转登录的地址，内网跳智能网关的地址
  const redirectPath = isInternal() ? '/v2/login/' : '/_logout/';
  window.location.href = `${redirectPath}?url=${currentUrl}`;
  logger.info('Logout');
}

/**
 * 不刷新页面跳转登录页，不会转那么久
 * @param history
 */
export function logoutByHistory(history: History) {
  localStorage.removeItem(BUGLY_LOGIN_STORAGE_KEY);
  clearAllCookie();
  const currentUrl = encodeURIComponent(location.href);

  if (isInternal()) {
    history.push({
      pathname: '/login',
      search: `?url=${currentUrl}`,
    });
    return;
  }

  window.location.href = `/_logout/?url=${currentUrl}`;
}

/**
 * 带登录态跳转到腾讯云
 * @param uin
 * @param saasToken
 * @param target 腾讯云的目标地址
 */
export function jumpToTencentCloud(uin: string, saasToken: string, target: string) {
  const url = new URL('https://cloud.tencent.com/login/saas/jumplogin');
  url.searchParams.set('SaaSToken', saasToken);
  url.searchParams.set('s_url', target);
  url.searchParams.set('clientUA', navigator.userAgent);
  url.searchParams.set('platform', 'bugly');
  url.searchParams.set('uin', uin);
  url.searchParams.set('ownerUin', uin);

  window.open(url.toString(), '_blank');
}
